import CartDetails from "./CartDetails";

export default CartDetails;